import { BaseAPI } from '../BaseApi';
import { DocumentCategoriesByName, IDocumentCategory } from '../../types/order/documents/IDocumentCategoryType';
import { eAPITags } from '../eAPITags';
import { categorySortingComparator } from '../../utilities/documents/categorySorting';
import { CACHE_TIME } from '../../utilities/Constants.APIConfig';

interface NormalizedDocumentCategoryData {
  allCategories: IDocumentCategory[];
  activeCategories: IDocumentCategory[];
  sortedActiveCategories: IDocumentCategory[];
  documentCategoriesByName: DocumentCategoriesByName;
}

export const DocumentCategoriesApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listDocumentCategories: build.query<NormalizedDocumentCategoryData, void>({
      query: () => '/timber/api/internal/document-categories',
      transformResponse: (response: IDocumentCategory[]) => {
        const activeCategories = response.filter((category) => !category.isLegacy && category.isUploadableByUser);
        const documentCategoriesByName = {};
        response.forEach((category) => (documentCategoriesByName[category.name] = category));
        return {
          allCategories: response,
          activeCategories,
          sortedActiveCategories: activeCategories.toSorted(categorySortingComparator),
          documentCategoriesByName,
        };
      },
      keepUnusedDataFor: CACHE_TIME,
      providesTags: () => [{ type: eAPITags.DocumentCategories }],
    }),
  }),
  overrideExisting: false,
});

export const { useListDocumentCategoriesQuery } = DocumentCategoriesApi;
export const defaultNormalizedDocumentCategoriesData: NormalizedDocumentCategoryData = {
  allCategories: [],
  activeCategories: [],
  sortedActiveCategories: [],
  documentCategoriesByName: {},
};
